import React, { useState } from "react";
import styles from "./style.module.css";
import KPIMetricsLabels from "components/Next/Dashboard/KPIMetricsLabels";
const ComparisonChartOptions = ({ id, comparisonOptions, comparisonChartOptions, updateComparisonChartOptions, useReportIdForChatGPTReducer }) => {
    if (!comparisonOptions?.dateField) {
        return null;
    }
    const [inputValue, setInputValue] = useState(comparisonChartOptions?.granularity);
    const handleGranularityChange = (inputValue) => {
        if (isNaN(inputValue)) {
            updateComparisonChartOptions({ ...comparisonChartOptions, granularity: 0.1 });
            setInputValue(5);
        }
        const value = Math.floor((inputValue + Number.EPSILON) * 10) / 10;
        if (!value || value < 0.1) {
            updateComparisonChartOptions({ ...comparisonChartOptions, granularity: 0.1 });
            setInputValue(0.1);
        }
        else {
            updateComparisonChartOptions({ ...comparisonChartOptions, granularity: value });
            setInputValue(value);
        }
    };
    const commitValue = () => {
        handleGranularityChange(Number(inputValue));
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.target.blur(); // remove focus to also trigger onBlur if you want
            commitValue();
        }
    };
    const handleBlur = () => {
        commitValue();
    };
    return (React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "flex-start", pointerEvents: "visible" } },
        React.createElement("div", { className: styles.comparisonChartSettingWrapper },
            React.createElement("div", null, "Minimum Vertical Axis Scale:"),
            React.createElement("input", { value: inputValue, onChange: (val) => setInputValue(val.currentTarget.value), onBlur: handleBlur, onKeyDown: handleKeyDown, style: { backgroundColor: "#ffffff", maxWidth: "80px" } })),
        React.createElement("div", { className: styles.comparisonChartCheckboxWrapper, onClick: () => updateComparisonChartOptions({
                ...comparisonChartOptions,
                normalize: !comparisonChartOptions.normalize
            }) },
            React.createElement("input", { type: "checkbox", checked: comparisonChartOptions.normalize, readOnly: true }),
            "Keep Vertical Axis Scales Consistent"),
        React.createElement("div", { style: { fontWeight: "bold", marginBottom: "8px" } }, "What labels would you like to use in your analysis?"),
        React.createElement(KPIMetricsLabels, { id: id, useReportIdForChatGPTReducer: useReportIdForChatGPTReducer })));
};
export default ComparisonChartOptions;
